import { useMemo, useState } from 'react';

export default function StatTable({
  columns,
  rows,
  empty = '暂无数据',
  pageSize = 20,
}: {
  columns: string[];
  rows: (string | number)[][];
  empty?: string;
  pageSize?: number;
}) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
  const current = Math.min(page, totalPages);
  const slice = useMemo(
    () => rows.slice((current - 1) * pageSize, current * pageSize),
    [rows, current, pageSize]
  );

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-background-100 text-left text-foreground-600">
            <tr>
              {columns.map((c) => (
                <th key={c} className="px-4 py-2.5 font-medium whitespace-nowrap">
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-background-100">
            {slice.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-4 py-8 text-center text-foreground-500">
                  {empty}
                </td>
              </tr>
            ) : (
              slice.map((row, i) => (
                <tr key={`${row[0]}-${i}`} className="hover:bg-background-100/70">
                  {row.map((cell, j) => (
                    <td
                      key={`${i}-${j}`}
                      className={`px-4 py-2.5 ${j === 0 ? 'text-foreground-900' : 'text-foreground-700'}`}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {rows.length > pageSize && (
        <div className="flex items-center justify-between px-4 py-3 border-t border-background-100 text-xs text-foreground-500">
          <span>
            共 {rows.length} 条，第 {current}/{totalPages} 页
          </span>
          <div className="flex gap-2">
            <button
              type="button"
              disabled={current <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              className="px-2 py-1 border border-background-200 rounded-md disabled:opacity-40"
            >
              上一页
            </button>
            <button
              type="button"
              disabled={current >= totalPages}
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              className="px-2 py-1 border border-background-200 rounded-md disabled:opacity-40"
            >
              下一页
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
